import { useMemo } from 'react';

import { AgentParameter, AgentParameterType } from '@frontend/types';

type UseUnusedParametersReturn = {
  unusedParams: Array<AgentParameter<AgentParameterType>>;
};

export function useUnusedParameters(
  parameters: Array<AgentParameter<AgentParameterType>> = [],
  promptTemplate: string = ''
): UseUnusedParametersReturn {
  const unusedParams = useMemo(() => {
    if (!parameters.length) return [];

    const usedVariables = new Set<string>();
    const matches = promptTemplate?.matchAll(/\[\[\s*([^[\]]+?)\s*\]\]/g);

    for (const match of matches ?? []) {
      // Decode HTML entities and trim whitespace
      const decodedVariable = match[1].replace(/&nbsp;/g, ' ').trim();
      usedVariables.add(decodedVariable);
    }

    return parameters.filter(param => !usedVariables.has(param.name));
  }, [parameters, promptTemplate]);
  return {
    unusedParams,
  };
}
